import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import GTMService from '../../services/gtmService';

interface UserData {
  userId: string;
  role: string;
  isAuthenticated: boolean;
  plan?: string;
}

const GoogleTagManager: React.FC = () => {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    GTMService.initDataLayer();
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    const title = document.title;

    GTMService.trackPageView(path, title);
  }, [location]);

  useEffect(() => {
    if (!user || !isAuthenticated) return;

    const userData: UserData = {
      userId: user._id,
      role: user.role,
      isAuthenticated: true,
    };

    if (user.subscription && user.subscription.plan) {
      userData.plan = user.subscription.plan;
    }

    GTMService.pushUserData(userData);
  }, [isAuthenticated, user]);

  return null;
};

export default GoogleTagManager;
